import React, { Component } from 'react'
import strings from 'translations/ro.json'

class TheNavBar extends Component {
	render() {
		return (
			<nav>
				<ul>
					<li><a href="#springboard">{strings.navbar.home}</a></li>
					<li><a href="#products">{strings.navbar.products}</a></li>
					<li><a href="#clients">{strings.navbar.clients}</a></li>
					<li><a href="#contact">{strings.navbar.contact}</a></li>
				</ul>
			</nav>
		)
	}
}

export default TheNavBar



// WEBPACK FOOTER //
// ./src/components/ui/NavBar.js